import { Trans } from '@lingui/react/macro';
import classNames from 'classnames';
import { ChampionshipMediaKindRow } from 'modules/championship/domain/graphql/championship-media';
import React from 'react';
import UDText from 'ud-ui/components/text';

/** Готовность типа медиа к генерации: шаблон есть / шаблона нет / тип ещё не поддержан. */
export type MediaKindState = 'ready' | 'missing' | 'soon';

export function mediaKindState(row: ChampionshipMediaKindRow): MediaKindState {
  if (!row.supported || row.blockedReason === 'unsupported') return 'soon';
  if (row.blockedReason === 'no_template' || !row.templateName) return 'missing';
  return 'ready';
}

/** Тон пилюли — цвет состояния темы; у «скоро» своего исхода нет, он нейтральный. */
const TONE_CLASS: Record<MediaKindState, string> = {
  ready: 'bg-CaseSuccessSurface text-CaseSuccessText',
  missing: 'bg-CasePendingSurface text-CasePendingText',
  soon: 'bg-surfaceSunken text-inkSecondary',
};

interface MediaKindStatusProps {
  state: MediaKindState;
}

/**
 * Статус типа медиа на вкладке «Медиа» турнира — пилюля со словом, а не значок: прежний «○»
 * походил на радиокнопку и ничего не сообщал (IMGM-1509).
 */
const MediaKindStatus = ({ state }: MediaKindStatusProps) => (
  <UDText
    as="span"
    variant="text-2"
    className={classNames('rounded-pill inline-flex h-7 items-center px-3 whitespace-nowrap', TONE_CLASS[state])}
    data-testid="media-kind-status"
    data-state={state}
  >
    {state === 'ready' ? <Trans>Готов к генерации</Trans> : state === 'missing' ? <Trans>Нет шаблона</Trans> : <Trans>Скоро</Trans>}
  </UDText>
);

export default React.memo(MediaKindStatus);
